export default ({ store: { getters }, redirect, route }) => {
    if (!getters['auth/isLoggedIn'] && route.path !== '/login') {
        redirect('/login');
    }
};
